import * as React from 'react';
import { ReplacementValue } from '../../../common/utilities/StringInterpolation';
import { disabledText, SettingsStyles } from '../../styles/CommonStyles';

export interface TestIdProp {
  testId?: string;
}

export interface SettingsSectionProps<T = JSX.Element> extends TestIdProp{
  readonly title: React.ReactNode;
  readonly description?: ReplacementValue<T> | ReplacementValue<T>[];
  readonly disabled?: boolean;
}

export const SettingsSection: React.FunctionComponent<SettingsSectionProps> = function SettingsSection(props) {
  const descriptionDivClassName = `${SettingsStyles.settingsGroupDescription} ${props.disabled ? disabledText : ''}`;
  return (
    <div className={SettingsStyles.settingsGroup}
         data-tb-test-id={props.testId}>

    {props.title && <div className={SettingsStyles.settingsGroupName}> {props.title} </div>}

    <div className={SettingsStyles.indent}>
      {
        props.description &&
        (
          <div className={descriptionDivClassName}
               data-tb-test-id={`${props.testId}-details`}>
            {props.description}
          </div>
        )
      }
      {props.children}
    </div>

  </div>
  );
};
